import Phaser from 'phaser';
import {
  ART_MANIFEST_KEY,
  ART_MANIFEST_PATH,
  ART_SHEETS,
  ensureArt,
  queueArtOverrides,
  type ArtManifest,
} from '../assets/artSheets';
import { gameAudio } from '../audio/audio';
import { saves } from '../records';
import { createPixelFont } from '../ui/pixelFont';
import { applySettings } from './SettingsScene';

/**
 * Loads audio and the art manifest, loads any art overrides it lists, generates placeholders for
 * everything else, then hands off to the title (which goes on to the menu).
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    gameAudio.load(this);
    this.load.json(ART_MANIFEST_KEY, ART_MANIFEST_PATH);
  }

  create(): void {
    const { sound, ambience } = saves().save.settings;
    gameAudio.init(this, sound, ambience);
    applySettings(saves().save.settings);
    const manifest = this.cache.json.get(ART_MANIFEST_KEY) as ArtManifest | undefined;
    if (queueArtOverrides(this, manifest) > 0) {
      this.load.once(Phaser.Loader.Events.COMPLETE, () => this.finish());
      this.load.start();
    } else {
      this.finish();
    }
  }

  private finish(): void {
    ensureArt(this);
    createPixelFont(this);
    if (import.meta.env.DEV && new URLSearchParams(window.location.search).has('artExport')) {
      window.__artExport = ART_SHEETS.map((s) => ({
        key: s.key,
        frameWidth: s.frameWidth,
        frameHeight: s.frameHeight,
        frames: [...s.frames],
        png: (this.textures.get(s.key).getSourceImage() as HTMLCanvasElement).toDataURL(
          'image/png',
        ),
      }));
    }
    this.scene.launch('Wipe');
    this.scene.start('Title');
  }
}
